import React from 'react';
import { getDomain } from '@web/tools/getDomain';
import { useUser } from '@sde/widgets-core/src/redux/resources/user';
import { useProvider } from '@src/state/provider';

export const TrackItTopBar = (abyssHeaderStyle) => {
  const { user } = useUser.state();
  const { provider } = useProvider.state();
  const domain = getDomain('sde-trackit', 3400);
  return (
    <abyss-parcel
      user={JSON.stringify(user)}
      provider={JSON.stringify(provider)}
      abyssheaderstyle={JSON.stringify(abyssHeaderStyle)}
      scriptdomain={domain}
      import='trackit-top-bar@dev'
    />
  );
};
